import { Divider } from "@mui/material";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Item from "components/common/plans/item";
import { fetchPlansAsync } from "components/common/plans/plans.slice";
import { useTranslate } from "hooks/useTranslate";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { PAGE_SIZE, brandDeadlinesType, initiativePlansType } from "utils/CommonConstants";
import FilterButtons from "../FilterButtons";
import NoPropertyPlansBanner from "./NoPropertyPlansBanner";

interface Props {
  type: string;
}

function IndividualTypeList(props: Props) {
  const { type = "" } = props;
  const translate = useTranslate();
  const params = useParams();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(1);
  const { filters } = useAppSelector((state) => state.aboveProperty);
  const { list, totalRecords, planShowLoader } = useAppSelector((state) => state.plans);
  const { functionalAreas, searchText } = filters.individualPropertyFilters[type];

  useEffect(() => {
    dispatch(
      fetchPlansAsync({
        filter: { innCode: params?.inncode, functionalAreaIds: functionalAreas },
        pagination: { page, size: PAGE_SIZE },
        searchText,
        planType:
          type === translate("dashboard.IndividualProperty.Initiative") ? [initiativePlansType] : [brandDeadlinesType],
        fetchAllImplementedPlans: true
      })
    );
  }, [page, functionalAreas, searchText]);

  useEffect(() => {
    setPage(1);
  }, [functionalAreas, searchText]);

  const fetchMore = () => {
    setPage((pageNo) => pageNo + 1);
  };
  return (
    <>
      <FilterButtons
        isSearchBarVisible
        isFunctionalAreaVisible
        filterType={type}
        searchPredefinedValue={searchText}
        parentView="individualPropertyFilters"
        searchBarPlaceHolder={translate("dashboard.SearchBarPlaceholder")}
      />
      <Divider />
      {list?.length ? (
        <Scroller
          dataLength={list.length}
          loadMore={fetchMore}
          totalList={totalRecords}
          label={translate("dashboard.PlanLabel")}
        >
          {list.map((item: any) => {
            return (
              <Item
                key={item.id}
                suggested={false}
                isBookmarked={false}
                item={item}
                redirectFromDashboard={true}
                individualPropertyInncode={params?.inncode}
              />
            );
          })}
        </Scroller>
      ) : (
        !planShowLoader && <NoPropertyPlansBanner />
      )}
    </>
  );
}

export default IndividualTypeList;
